<template>
  <div class="vouchersList">
    <div v-if="couponsList.length === 0">
      <van-empty description="暂无可用卡券" />
    </div>
    <div v-else>
      <!--      <div class="remind">-->
      <!--        <van-cell center title="过期提醒">-->
      <!--          <template #right-icon>-->
      <!--            <van-switch v-model="remindChecked" size="24" />-->
      <!--          </template>-->
      <!--        </van-cell>-->
      <!--        <van-field v-if="remindChecked" v-model="text" type="digit" label="提醒期限" placeholder="过期前n天提醒" />-->
      <!--      </div>-->
      <van-list
        v-model="loading"
        :offset="300"
        :finished="finished"
        finished-text="没有更多了"
        class="list"
        @load="onLoad"
      >
        <div v-for="item in couponsList" :key="item.id" class="listItem">
          <div class="top">
            <div class="right">
              <div class="name">{{ item.couponName }}</div>
              <div class="time">
                <van-tag type="primary">
<!--                  {{ item.consumeTypeName }}-->
                  {{ item.consumeType === 'COST_PER_TIMES' ? '次数抵扣券' : '' }}
                </van-tag>
                <van-tag v-if="item.relateBookingInfo" type="success" style="margin-left: 10px" @click="() => showName(item.relateBookingInfo)">
                  {{ item.relateBookingInfo.mealRuleName | filterName }}
                </van-tag>
              </div>
            </div>
            <div class="left">
              {{ item.deductionTimes || item.deductionFee }}{{ item.consumeType === 'COST_PER_TIMES' ? '次' : '元' }}
            </div>
          </div>
          <div class="down">
            <div class="close">
              <div v-if="item.expireDate" class="rule">{{ item.createTime }}~{{ item.expireDate }}</div>
              <div v-else class="rule">长期有效</div>
              <div>{{ item.couponSerial }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="getBtn">
      <router-link to="voucherInvalid" class="btn left" @click="getCoupons">
        历史卡券
      </router-link>
      <div class="btn right" @click="getCoupons">
        获取卡券
      </div>
    </div>
  </div>
</template>

<script>
import { myCoupons } from '@/api/user';
import { Dialog } from 'vant';

export default {
  name: 'VouchersList',
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      remindChecked: false,
      text: '',
      loading: false,
      showRule: false,
      couponsList: []
    };
  },
  filters: {
    filterName(val) {
      if (val.length > 12) {
        let str = '';
        str = val.substring(0, 12) + '...';
        return str;
      } else {
        return val;
      }
    }
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.size);
    },
    finished() {
      return this.page > this.maxPage;
    }
  },
  watch: {
    couponsList: {
      handler(nv) {
        this.loading = false;
      },
      immediate: true
    }
  },
  activated() {
    if (this.page !== 1 || this.couponsList.length) {
      this.page = 1;
      this.couponsList = [];
      this.total = [];
      this.getList();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const data = {
        queryType: 'ACTIVE',
        page: this.page,
        size: this.size
      };
      myCoupons(data).then(res => {
        this.couponsList.push(...res.data.list);
        this.total = res.data.totals;
        if (res.data.page === 1) {
          this.$emit('setCouponsTotal', res.data.totals);
        }
      });
    },
    onLoad() {
      if (this.page > this.maxPage) {
        return;
      } else {
        ++this.page;
      }
      this.getList();
    },
    getCoupons() { // 获取卡券
      this.$router.push({ name: 'couponList' });
    },
    showName(info) {
      Dialog.alert({
        title: '关联餐次',
        message: `${info.bookingDate} ${info.mealTimeStart}~${info.mealTimeEnd} ${info.mealRuleName}`,
      }).then(() => {
        // on close
      });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.vouchersList {
  position: relative;
  .remind {
    padding: 0.09rem 0;

    .van-field__label {
      color: #333;
    }
  }

  .list {
    .change_val(padding-bottom, 184);
    .listItem {
      background: #FFFFFF;
      border: 1px solid #EFEFF4;
      box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
      opacity: 1;
      border-radius: 6px;
      .change_val(margin, 16);

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15294117647058825);
        opacity: 1;
        .change_margin(padding, 22, 38);
        .right {
          .name {
            .change_val(font-size, 32);
          }

          .time {
            line-height: 33px;
            color: rgba(51, 51, 51, 0.7);
            opacity: 1;
            .change_val(margin-top, 18);
            .change_val(font-size, 24);
            .change_val(line-height, 33);
          }
        }
        .left {
          color: #3B86FF;
          .change_val(font-size, 42);
        }
      }

      .down {
        display: flex;
        flex-direction: column;
        color: rgba(51, 51, 51, 0.7);
        .change_margin(padding, 19, 38);
        .close {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .rule {
            display: flex;
            align-items: center;
            .arrow {
              margin-left: 0.04rem;
            }
          }
        }
        .open {
          .change_val(margin-top, 16);

          .item {
            color: rgba(51, 51, 51, 0.7);
            .change_val(font-size, 20);
            .change_val(line-height, 33);
          }
        }
      }
    }
  }
  .finishedText {
    display: flex;
    justify-content: center;
    .change_margin(margin, 44, 20);

    .link {
      display: flex;
      align-items: center;

      .arrow {
        margin-left: 0.04rem;
      }
    }
  }

  .getBtn {
    position: fixed;
    .change_val(bottom, 100);
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 999px;
      .change_val(width, 300);
      .change_val(height, 80);
      color: #FFFFFF;
      cursor: pointer;
    }

    .left {
      .change_val(margin-right, 10);
      background-color: #f7a61f;
    }

    .right {
      .change_val(margin-left, 10);
      background-color: #1989fa;
    }
  }
}
</style>
